import React, { Component } from "react";
import Json from "..//dummy_data/users.json";
export default class Input extends Component {
  render() {
    function checkData() {
      let name = document.getElementById("name-input");
      let psw = document.getElementById("password-input");
      for (let i = 0; i < Json.length; i++) {
        if (Json[i].name === name.value) {
          if (Json[i].password === psw.value) {
            window.location.href = "/admin";
          } else {
            alert("Password invalid!");
          }
        }
      }
    }
    return (
      <>
        <div id="reg-form">
          <form>
            <p>
              <input
                type="text"
                id="name-input"
                placeholder="Введите имя"
                required
              ></input>
            </p>
            <p>
              <input
                type="password"
                id="password-input"
                placeholder="Password"
                required
              />
            </p>
            <p>
              <input type="button" name="submit" onClick={checkData} value="Войти"/>
              
            </p>
          </form>
          <p>
            <a href="/registration">
              <button>Register</button>
            </a>
          </p>
        </div>
      </>
    );
  }
}
